import styled, { css } from 'styled-components';
import smallBorderStyle from '../../utils/smallBorderStyle';
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

export default styled.h2`
  position: relative;
  margin-top: 0;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1.125;

  ${props => props.theme.isTablet && css`
    padding-top: .25rem;

    &:after {
      content: "";
      position: absolute;
      top: -.125rem;
      left: 0;
      ${() => smallBorderStyle()}
    }
  `};

  ${({ related }) => related && css`
    margin-top: .5rem;
    color: #fefefe;
  `};
`;
